import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

// import image1 from "./images./image1";
// import image2 from "./images./image2";
// import image3 from "/images.image3";
import { bannerImgUrls, StyledHeading, StyledImage, upimg } from "./Styled";
import { Box, Dialog, DialogActions, DialogContent, Button, DialogTitle, IconButton } from "@mui/material";
import { useForm } from "react-hook-form";
import InputContainer from "@egovernments/digit-ui-module-obps/src/pages/citizen/TCPForms/layout/inputContainer";
import { useLocation } from "react-router-dom";
// import ButtonWrapper from "../../ReusableComponents/ButtonsWrapper/ButtonWrapper";
// import EmployeeLoginCard from "../../../employee/Login/emplogin";
import EmployeeLogin2 from "./EmployeeLogin2";
import ButtonWrapper from "../../TCPForms/components/Button";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";

// import EmployeeLogin2 from "./EmployeeLogin2

const DALogin2 = ({ handleFlip, flipped }) => {
  const getUserType = () => Digit.UserService.getType();
  const navigate = useHistory();
  const stateId = Digit.ULBService.getCurrentTenantId();
  const [showOtpField, setOtpField] = useState(false);
  const [showsecotpField, setSecondOtpField] = useState(false);
  const [showName, setName] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loginSection, setLoginSection] = useState(false);
  const location = useLocation();
  const homepath = location?.pathname?.includes("digit-ui/citizen");
  const { handleSubmit, control, setValue, getValues, watch, reset } = useForm({});
  const history = useHistory();
  const { t } = useTranslation();
  useEffect(() => {
    const handleBack = () => {
      if (location.pathname === "DA") {
        navigate.push("digit-ui"); // Navigate to the landing page
      }
    };

    window.addEventListener("popstate", handleBack);
    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, [location, navigate]);

  const closeToast = () => {
    setShowToast(null);
  };

  const [activeTab, setActiveTab] = useState(1);
  const [showFeePopup, setShowFeePopup] = useState(false);

  const onTabChange = (key) => {
    setActiveTab(key);
  };

  const handlePopupClose = () => {
    setLoginSection(false);
  };

  const handleFeePopupClose = () => {
    setShowFeePopup(false);
  };

  const handleBackButton = () => {
    setApplicationFlow(null);
    history.push("/digit-ui");
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  useEffect(() => {
    let timer = setInterval(() => {
      setCurrentSlide((curr) => (curr + 1 < bannerImgUrls.length ? curr + 1 : 0));
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  const onSubmit = async (data) => {
    console.log(data);
    const { mobileNumber, otp, registeredName } = data;
    if (!showOtpField && !showName) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          userType: "citizen",
          type: "login",
          tenantId: stateId,
        },
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res?.isSuccessful) {
          setOtpField(true);
        }
      } catch (err) {
        setName(true);
        setShowToast({ error: true, message: `New User? Please register your detail in the portal` });
      }
    }
    console.log(otp, registeredName, showName, showOtpField, showsecotpField, "alllllll");
    if (showsecotpField) {
      const requestData = {
        name: registeredName,
        username: mobileNumber,
        otpReference: otp,
        tenantId: stateId,
        mobileNumber: mobileNumber,
      };
      try {
        const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.registerUser(requestData, stateId);
        Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
        Digit.UserService.setUser({ info, ...tokens });
        navigate.push("/digit-ui/citizen/profile");
      } catch (error) {
        setShowToast({ error: true, message: `Something went wrong, please try again!` });
      }
    }
    if (showName && !showOtpField && !showsecotpField) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          name: registeredName,
          userType: "citizen",
          type: "register",
          tenantId: stateId,
        },
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res?.isSuccessful) {
          setSecondOtpField(true);
        }
      } catch (err) {
        setShowToast({ error: true, message: `Something went wrong, please try again!` });
      }
    }
    if (showOtpField && !showName) {
      const requestData = {
        username: mobileNumber,
        password: otp,
        tenantId: stateId,
        userType: getUserType(),
      };
      try {
        const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.authenticate(requestData);
        console.log("outSideIfLogin", info);

        if (info?.uuid) {
          console.log("insideIfLogin", info);

          Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
          Digit.UserService.setUser({ info, ...tokens });
          navigate.push("/digit-ui/citizen/profile");
        } else {
          setShowToast({ error: true, message: `Something went wrong, please try again!` });
        }
      } catch (error) {
        setShowToast({ error: true, message: `Something went wrong, please try again!` });
      }
    }
  };

  return (
    <React.Fragment>
      {/* <LoginCard bgImg={"https://i.imgur.com/hhe2CrL.jpeg"}> */}
      <Box>
        {/* <StyledImage style={{ position: "absolute" }} src={upimg} alt="up-image" />
          <StyledHeading style={{ position: "absolute", top: "30px" }}>FAST & SIMPLIFIED TRUST BASED PLAN APPROVAL SYSTEM</StyledHeading> */}
        <div className="citizen-header-homepage">
          <StyledImage src={upimg} alt="up-image" />
          <StyledHeading>{t("FASTPAS.HOME.BANNER.SYSTEM_TITLE")}</StyledHeading>
        </div>
        <h2 className="citizen-login-header">{t("FASTPASS.HOME.CITIZEN.LOGIN_REGISTER")}</h2>
        <EmployeeLogin2 handleFlip={handleFlip} flipped={flipped} />
      </Box>

      <Dialog
        open={loginSection}
        onClose={handlePopupClose}
        maxWidth={"sm"}
        fullWidth={true}
        PaperProps={{
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const mobileNumber = formJson.mobileNumber;
            handleClose();
            console.log(mobileNumber);
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#406192",
            color: "white",
            background: `url('https://i.imgur.com/qfE8uLN.jpeg') center center / cover no-repeat`,
            height: "70%",
            width: "100%",
          }}
        >
          {/* <div style={{background: `url('https://imgur.com/qfE8uLN') center center / cover no-repeat`, height:"50%", width:"100%"}} > */}
        </DialogTitle>
        <h1 style={{ textAlign: "center", color: "#333", marginTop: "9px", fontSize: "20px", fontWeight: "bold", textDecoration: "none" }}>
          Mobile OTP Verification
        </h1>{" "}
        {/* <Typography */}
        {/* variant="h6" */}
        {/* sx={{ */}
        {/* zIndex: 2, */}
        {/* textShadow: "2px 2px 4px rgba(0, 0, 0, 0.6)", */}
        {/* }} */}
        {/* > */}
        {/* Mobile OTP Verification */}
        {/* </Typography> */}
        <IconButton
          aria-label="close"
          onClick={handlePopupClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 30,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {/* <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
            control={control}
            autoFocus
            required
            margin="dense"
            id="mobileNumber"
            name="mobileNumber"
            label="Mobile Number"
            type="number"
            fullWidth
            variant="standard"            
          />
          { (showOtpField || showsecotpField) && <TextField
            control={control}
            autoFocus
            required
            margin="dense"
            id="otp"
            name="otp"
            label="Enter OTP"
            type="text"
            fullWidth
            variant="standard"            
          />}
          </form> */}
          {
            loginSection && (
              //  <section className="container1" style={{ marginTop: 0 }}>
              <form onSubmit={handleSubmit(onSubmit)}>
                {/* <div className="formContainer"> */}
                {/* <div className="formInputContainer"> */}
                <div className="columnWrapper" style={{ flex: "0 0", textAlign: "center" }}>
                  <InputContainer
                    width="29vw"
                    control={control}
                    placeholder="Enter Mobile No."
                    //defaultValue={owner.mobileNumber}
                    name="mobileNumber"
                    type="textInput"
                    mobileNumber
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("MobileNo"),
                        message: "Please enter valid mobile no",
                      },
                    }}
                    maxLength={10}
                  />

                  {/* {showName &&
                                        <InputContainer
                                            control={control}
                                            placeholder="Enter Name"
                                            //defaultValue={owner.mobileNumber}
                                            name="registeredName"
                                            type="textInput"
                                            label={"Enter Name"}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern('Name'),
                                                    message: "Please enter only letters and spaces",
                                                },
                                            }}
                                        />} */}
                  {(showOtpField || showsecotpField) && (
                    <div style={{ marginTop: "10px" }}>
                      <InputContainer
                        width="29vw"
                        control={control}
                        placeholder="Enter Otp"
                        //defaultValue={owner.mobileNumber}
                        name="otp"
                        type="textInput"
                        // label={"Enter OTP:"}
                        maxLength={6}
                      />
                    </div>
                  )}
                </div>
                {/* </div> */}
                {/* <div style={{ marginLeft: '45%',marginTop:'10px'}}> */}
                {/* <ButtonWrapper */}
                {/* variant="contained" */}
                {/* size="medium" */}
                {/* label="Next" */}
                {/* type="submit" */}
                {/* sx={{ backgroundColor: '#1F4A7C', width: '10%', marginBottom: '3%'  }} */}
                {/* /> */}
                {/* </div> */}
                {/* </div> */}
              </form>
            )
            // </section>
          }
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit" onClick={handleSubmit(onSubmit)}>
            Send OTP
          </Button>
          <Button variant="contained" color="primary" onClick={handlePopupClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* <div style={{ marginLeft: '45%',marginTop:'10px'}}> 
                                <ButtonWrapper
                                     variant="contained"
                                     size="medium"
                                     label="Next"
                                     type="submit"
                                    sx={{ backgroundColor: '#1F4A7C', width: '10%', marginBottom: '3%'  }}
                             /> 
                             </div>  */}

      <Dialog
        open={showFeePopup}
        onClose={handleFeePopupClose}
        maxWidth={"sm"}
        fullWidth={true}
        PaperProps={{
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            console.log(formJson);
            this.onSubmit(formJson);
            handleClose();
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#406192",
            color: "white",
            background: `url('https://i.imgur.com/qfE8uLN.jpeg') center center / cover no-repeat`,
            height: "5vh",
            width: "100%",
          }}
        >
          <h2 style={{ textAlign: "center", color: "#333", marginTop: "20px", fontSize: "20px", fontWeight: "bold", textDecoration: "none" }}>
            Enter Amount
          </h2>{" "}
          {/* <div style={{background: `url('https://imgur.com/qfE8uLN') center center / cover no-repeat`, height:"50%", width:"100%"}} ></div>Fee Calculator */}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleFeePopupClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 30,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {/* <DialogContentText>Mobile Number OTP Verification</DialogContentText> */}
          {/* <TextField
            autoFocus
            required
            margin="dense"
            id="feeAmount"
            name="feeAmount"
            label="Enter Amount"
            type="number"
            fullWidth
            variant="standard"
            size="small"
          /> */}
          <div style={{ margin: "10px 10px" }}>
            <InputContainer
              width="32rem"
              control={control}
              placeholder="Enter Amount."
              //defaultValue={owner.mobileNumber}
              name="Amount"
              type="textInput"
              mobileNumber
              // label={"Enter Amount."}
              validation={{
                required: {
                  value: true,
                  message: "This field is required",
                },
                pattern: {
                  value: Digit.Utils.getPattern("Amount"),
                  message: "Please enter valid Amount",
                },
              }}
              maxLength={10}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit">
            Calculate Fee
          </Button>
          <Button variant="contained" color="primary" onClick={handleFeePopupClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      {false && (
        <section className="container1" style={{ marginTop: 0 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="formContainer">
              <div className="formHeaderContainer">
                <h2 className="formHeading">User Login</h2>
              </div>
              <div className="formInputContainer">
                <div className="columnWrapper" style={{ flex: "0 0" }}>
                  <InputContainer
                    control={control}
                    placeholder="Enter Mobile No."
                    //defaultValue={owner.mobileNumber}
                    width="29vw"
                    name="mobileNumber"
                    type="textInput"
                    label={"Enter Mobile No."}
                    mobileNumber
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                      pattern: {
                        value: Digit.Utils.getPattern("MobileNo"),
                        message: "Please enter valid mobile no",
                      },
                    }}
                    maxLength={10}
                  />
                  {showName && (
                    <InputContainer
                      control={control}
                      placeholder="Enter Name"
                      width={"29vw"}
                      //defaultValue={owner.mobileNumber}
                      name="registeredName"
                      type="textInput"
                      label={"Enter Name"}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        pattern: {
                          value: Digit.Utils.getPattern("Name"),
                          message: "Please enter only letters and spaces",
                        },
                      }}
                    />
                  )}
                  {(showOtpField || showsecotpField) && (
                    <InputContainer
                      control={control}
                      placeholder="Enter Otp"
                      width={"29vw"}
                      //defaultValue={owner.mobileNumber}
                      name="otp"
                      type="textInput"
                      label={"Enter OTP"}
                      maxLength={6}
                    />
                  )}
                </div>
              </div>
              <div style={{ marginLeft: "25%" }}>
                {/* <ButtonWrapper
                    variant="contained"
                    size="medium"
                    label="Next"
                    type="submit"
                    sx={{ backgroundColor: "#1F4A7C", width: "10%", marginBottom: "3%" }}
                  /> */}
                <ButtonWrapper
                  variant="contained"
                  size="medium"
                  label="Next"
                  type="submit"
                  sx={{ backgroundColor: "#325F9D", width: "5%", marginBottom: "5%" }}
                />
              </div>
            </div>
          </form>
        </section>
      )}
      {showToast && <Toast error={showToast?.error} warning={showToast?.warning} label={showToast?.message} onClose={closeToast} isDleteBtn={true} />}
    </React.Fragment>
  );
};

export default DALogin2;
